import React from 'react'
import { Svg, SvgProps } from '@pancakeswap/uikit'

const PoolAllocationChart: React.FC<SvgProps> = (props) => {
  return (
    <Svg viewBox="0 0 103 105" {...props}>
      <svg width="103" height="105" viewBox="0 0 403 405" fill="none" xmlns="http://www.w3.org/2000/svg">
        <ellipse
          cx="201.5"
          cy="202.5"
          rx="200.5"
          ry="199.5"
          transform="rotate(-90 201.5 202.5)"
          fill="#BDC2C4"
          stroke="#0E0E0E"
          strokeOpacity="0.05"
          strokeWidth="2"
        />
        <path
          d="M201.5 2.00002C243.63 2.00002 284.679 15.4044 318.763 40.2921C352.847 65.1798 378.217 100.273 391.236 140.542C404.255 180.811 404.255 224.189 391.236 264.458C378.217 304.727 352.847 339.82 318.763 364.708C284.679 389.596 243.63 403 201.5 403C159.37 403 118.321 389.596 84.2368 364.708C50.1527 339.82 24.7832 304.727 11.7642 264.458C-1.25475 224.189 -1.25475 180.811 11.7642 140.542L201.5 202.5L201.5 2.00002Z"
          fill="#D750B2"
          stroke="#0E0E0E"
          strokeOpacity="0.05"
          strokeWidth="2"
        />
        <path
          d="M201.5 2.00002C243.63 2.00002 284.679 15.4044 318.763 40.2921C352.847 65.1798 378.217 100.273 391.236 140.542C404.255 180.811 404.255 224.189 391.236 264.458C378.217 304.727 352.847 339.82 318.763 364.708L201.5 202.5L201.5 2.00002Z"
          fill="#A881FC"
          stroke="#0E0E0E"
          strokeOpacity="0.05"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <path
          d="M201.5 2.00002C243.63 2.00002 284.679 15.4044 318.763 40.2921C352.847 65.1798 378.217 100.273 391.236 140.542L201.5 202.5L201.5 2.00002Z"
          fill="#3AF3F8"
          stroke="#0E0E0E"
          strokeOpacity="0.05"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <path
          d="M201.5 2.00002C243.63 2.00002 284.679 15.4044 318.763 40.2921L201.5 202.5L201.5 2.00002Z"
          fill="#10AC87"
          stroke="#0E0E0E"
          strokeOpacity="0.05"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <path
          d="M201.5 2.00002C218.235 2.00002 234.904 4.11632 251.114 8.29909L201.5 202.5L201.5 2.00002Z"
          fill="#93D45A"
          stroke="#0E0E0E"
          strokeOpacity="0.05"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <path
          d="M201.5 2.00002C222.435 2.00002 243.239 5.3116 263.149 11.8132L201.5 202.5L201.5 2.00002Z"
          fill="#8FD74F"
          stroke="#0E0E0E"
          strokeOpacity="0.05"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <path
          d="M201.5 2.00002C205.679 2.00002 209.856 2.13198 214.027 2.39565L201.5 202.5L201.5 2.00002Z"
          fill="#C4C4C4"
          stroke="#0E0E0E"
          strokeOpacity="0.05"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <path
          d="M201.5 2.00002C209.859 2.00002 218.211 2.52807 226.504 3.58101L201.5 202.5L201.5 2.00002Z"
          fill="#FFD307"
          stroke="#0E0E0E"
          strokeOpacity="0.05"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <ellipse
          opacity="0.2"
          cx="201.5"
          cy="202.5"
          rx="200.5"
          ry="199.5"
          transform="rotate(-90 201.5 202.5)"
          stroke="#280D5F"
          strokeWidth="3"
        />
      </svg>
    </Svg>
  )
}

export default PoolAllocationChart
